<script>
    import Category from '../Category.svelte';
    import {Link} from 'svelte-routing';
    import { FirebaseApp, Doc, Collection } from 'sveltefire';
    import Item from '../Item.svelte';
    import Route from 'svelte-routing/src/Route.svelte';
import { startsWith } from 'svelte-routing/src/utils';
import All from './All.svelte';

    export let sku;
    export let currency;

    let currencies = [
        {shorthand: 'cad', prefix: '$', suffix: ' CAD', name: 'Canadian Dollar'},
        {shorthand: 'czk', prefix: 'Kč', suffix: '', name: 'Czech Koruna'},
        {shorthand: 'dkk', prefix: 'kr.', suffix: '', name: 'Danish Krone'}, 
        {shorthand: 'eur', prefix: '€', suffix: '', name: 'Euro'},
        {shorthand: 'gbp', prefix: '£', suffix: '', name: 'Pound Sterling'},
        {shorthand: 'huf', prefix: 'Ft', suffix: '', name: 'Hungarian Forint'},
        {shorthand: 'nok', prefix: 'kr.', suffix: '', name: 'Norwegian Krone'},
        {shorthand: 'pln', prefix: 'zł', suffix: '', name: 'Polish Złoty'},
        {shorthand: 'sek', prefix: 'kr.', suffix: '', name: 'Swedish Krona'},
        {shorthand: 'usd', prefix: '$', suffix: '', name: 'US Dollar'}];

    let convertTime;
    $: convertTime = function(timestamp){
        var a = timestamp.toDate();
        var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
        var year = a.getFullYear();
        var month = months[a.getMonth()];
        var date = a.getDate();
        return currency.shorthand == 'usd' ? `${month} ${date}, ${year}` : `${date} ${month} ${year}`;
    };

    function updateTitle(data) {
        if(data != undefined)
            title = data.title;
        else title = '';
    }

    let sales;
    let title = '';
</script>

<svelte:head>
    <meta name="description" content="Price, sale, and content history for ${title} on Stadia.">
    <title>{title} - StadiaDB</title>
</svelte:head>

<Doc let:traceId path={'pages/details'} let:ref let:data={data} let:error>
    {#if data.note != ''}
    <div class="full-width notice">
        <p>{@html data.note}</p>
    </div>
    {/if}

    <div slot="fallback">
        <div class="full-width notice">
            <p><strong>Something went wrong</strong>, you're not supposed to see this.</p>
        </div>
    </div>
</Doc>

<br />
<Doc let:traceId path={'games/'+sku} let:ref let:data={game} on:data={(e) => {updateTitle(e.detail.data)}}>
    <div class="pure-g">
        <div class="pure-u-1 pure-u-md-1-2">
            {#if game.logo != null}
                <img src="/img/games/{game.logo}" alt="{game.title}" class="logo {game.noInvert != null ? '' : 'invert'} {game.invertedLogo != null ? 'nonInverted' : ''}" />
                {#if game.invertedLogo != null}
                    <img src="/img/games/{game.invertedLogo}" alt="{game.title}" class="logo inverted" />
                {/if}
            {:else}
                <h2>{game.title}</h2>
            {/if}
            <p>{game.description}</p>
            {#if game.note != null}
            <br />
            <p>&#x1f6c8; {game.note}</p>
            {/if}
        </div>
        <div class="pure-u-1 pure-u-md-1-2 details">
            <div>
                {#if game.type < 2}
                    <div class="pure-g buttons">
                        <div class="pure-u-1-2">
                            <a class="pure-button" href="https://stadia.google.com/store/details/{game.id}/sku/{sku}">Store Link</a>
                        </div>
                        <div class="pure-u-1-2">
                            <a class="pure-button" href="https://stadia.google.com/player/{game.id}">Play</a>
                        </div>
                    </div>
                {:else}
                    <a class="pure-button" href="https://stadia.google.com/store/details/{game.id}/sku/{sku}">Store Link</a>
                {/if}
                <ul style="list-style:none" class="nonul">
                    <li>Released: {convertTime(game.added)}</li>
                    <li>Type: {game.type == 0 ? 'Game' :
                                game.type == 1 && game.playable ? 'Bundle' :
                                game.type == 1 ? 'Add-on Bundle' :
                                game.type == 2 ? 'Add-on' :
                                'Subscription'}</li>
                    {#if game.pro != null}
                        <li>Pro:
                        {#each game.pro as pro, i}
                            {i % 2 != 0 ? ' — ' : ''}{convertTime(pro)}
                        {/each}
                        {#if game.pro[game.pro.length-1].toDate() > Date.now()}
                            (leaving soon)
                        {/if}
                        </li>
                    {/if}
                    {#if game.prices != null && game.prices['usd'] != 0 }
                        <li>Price: 
                        {#if game.prices[currency.shorthand] != null}
                            {#if sales != null}
                                {#if sales.filter((c) => c.end.toDate() > Date.now()).length > 0}
                                    {#if isNaN(sales.filter((c) => c.end.toDate() > Date.now())[0].discount)}
                                        {#if isNaN(sales.filter((c) => c.end.toDate() > Date.now())[0].discount[currency.shorthand])}
                                            {currency.symbol}{game.prices[currency.shorthand]}
                                        {:else}
                                            {#if sales.filter((c) => c.end.toDate() > Date.now())[0].pro}<img src="/img/stadia_pro_badge_small.svg" class="pro-badge" alt="pro" />{/if}
                                            {currency.symbol}{(game.prices[currency.shorthand] * (1.0 - sales.filter((c) => c.end.toDate() > Date.now())[0].discount[currency.shorthand])).toFixed(2)} <strike>{currency.symbol}{game.prices[currency.shorthand]}</strike>
                                        {/if}
                                    {:else}
                                        {currency.symbol}{(game.prices[currency.shorthand] * (1.0 - sales.filter((c) => c.end.toDate() > Date.now())[0].discount)).toFixed(2)} <strike>{currency.symbol}{game.prices[currency.shorthand]}</strike>
                                    {/if}
                                {:else}
                                    {currency.symbol}{game.prices[currency.shorthand]}
                                {/if}
                            {:else}
                                {currency.symbol}{game.prices[currency.shorthand]}
                            {/if}
                        {:else}
                            <Link to="contribute">Missing — Add it!</Link>
                        {/if}
                        </li>
                        {#if sales != null}
                            {#if sales.filter((c) => c.end.toDate() > Date.now()).length > 0}
                                <li>Sale ends: {convertTime(sales.filter((c) => c.end.toDate() > Date.now())[0].end)}</li>
                                <li>Sale started: {convertTime(sales.filter((c) => c.end.toDate() > Date.now())[0].start)}</li>
                            {/if}
                        {/if}
                    {/if}
                    {#if game.type == 0}
                    <Collection path={'games'} query={(ref) => ref.where('contains', 'array-contains', sku)} let:data={bundles}>
                        {#if bundles != null && bundles.length > 0}
                            <li>In bundles: <ul style="list-style:disc">
                            {#each bundles as bundle}
                                <li><Link to="details/{bundle.ref.id}">{bundle.title}</Link>{bundle.playable == false && bundle.playable != null ? ' (discontinued)' : ''}</li>
                            {/each}
                            </ul></li>
                        {/if}
                    </Collection>
                    <Collection path={'games'} query={(ref) => ref.where('id', '==', game.id).where('type', '>', 1)} let:data={addons}>
                        {#if addons != null && addons.length > 0}
                            <li>Add-ons: <ul style="list-style:disc">
                            {#each addons as addon}
                                <li><Link to="details/{addon.ref.id}">{addon.title}</Link></li>
                            {/each}
                            </ul></li>
                        {/if}
                    </Collection>
                    {:else if game.type == 1}
                    {#if game.contains != null}
                        <li>Comes with: <ul style="list-style:disc">
                        {#each game.contains as sku}
                            <li>
                                <Doc let:traceId path={'games/'+sku} let:ref let:data>
                                    <Link to="details/{sku}">{data.title}</Link>
                                </Doc>
                            </li>
                        {/each}
                        </ul></li>
                    {/if}
                    <!-- <Collection path={'games'} query={(ref) => ref.where('__name__', 'in', game.contains)} let:data={bundles}>
                        {#if bundles != null && bundles.length > 0}
                            <li>Comes with: <ul style="list-style:disc">
                            {#each bundles as bundle}
                                <li><Link to="details/{bundle.ref.id}">{bundle.title}</Link></li>
                            {/each}
                            </ul></li>
                        {/if}
                    </Collection> -->
                    {:else if game.type >= 2}
                    <Collection path={'games'} query={(ref) => ref.where('id', '==', game.id).where('type', '==', 0)} let:data={base}>
                    <li>Use for: <Link to="details/{base[0].ref.id}">{base[0].title}</Link></li>
                    </Collection>
                    {/if}
                </ul>
            </div>
        </div>
    </div>

    {#if game.reviews != null}
    <br /><br />
        <div class="full-width banner"><br />
        <center>
            <svg class="ign-icon icon-logo" focusable="false" viewBox="0 0 182 55" aria-hidden="false" role="img" style="cursor:inherit;user-select:none;width:200px;height:100%;display:inline-block;flex-shrink:0;font-size:1.5rem;max-width:182px"><title>IGN Logo</title><g stroke="none" fill-rule="evenodd"><path d="M97.2501416,32.2561667 L97.2501416,22.4167222 L123.688285,22.4236667 C126.372368,22.4236667 128.561099,24.5945 128.561099,27.2731111 L128.561099,38.9672778 C128.561099,44.9858889 123.740882,49.9672778 117.613548,49.9711667 L100.688105,49.9831111 C88.1440193,49.9831111 77.9951538,39.8772778 77.9951538,27.3881111 C77.9951538,14.9089444 88.2060774,4.79366667 100.707863,4.79366667 L126.91308,4.79366667 L126.91308,15.1747778 L100.702298,15.1747778 C93.9449214,15.1747778 88.3961477,20.6433889 88.3961477,27.3881111 C88.3961477,34.1231111 93.8636615,39.5950556 100.684765,39.5942222 L118.169288,39.5942222 L118.169288,32.2561667 L97.2501416,32.2561667 Z M74.5580254,4.73744444 C74.5580254,4.73744444 74.5638694,8.05911111 74.5638694,8.08022222 L74.5638694,50.0016111 L69.3487624,50.0016111 L69.1133312,50.0016111 C66.4492853,50.0016111 64.2725208,47.8438333 64.2725208,45.1846667 L64.2725208,12.4643889 L64.2727991,4.73744444 L74.5580254,4.73744444 Z M177.034127,4.76322222 C179.699008,4.76322222 181.858519,6.9235 181.858519,9.58211111 L181.858519,39.5876667 C181.858519,45.6126667 176.956763,50.4976667 170.92043,50.4976667 L170.733699,50.4976667 C166.779513,50.4976667 163.330139,48.5354444 161.408286,45.3187778 L144.004745,14.8490556 C143.861705,14.5835 143.61069,14.5048889 143.394182,14.5048889 C143.131757,14.5048889 142.901613,14.6493333 142.780558,14.8632222 C142.722396,14.9557222 142.677592,15.066 142.677592,15.1837778 L142.680653,50.0015556 L137.203956,50.0015556 C134.540745,50.0015556 132.372051,47.8437778 132.372051,45.1848889 L132.372051,15.1837778 C132.372051,9.15877778 137.266292,4.27433333 143.302347,4.27433333 L143.488243,4.27433333 C147.443265,4.27433333 150.971672,6.38961111 152.894916,9.60683333 L170.192987,39.8790556 C170.409772,40.1632222 170.605687,40.2635 170.826369,40.2635 C171.086846,40.2635 171.31365,40.1237778 171.436931,39.9162778 C171.491754,39.8332222 171.510121,39.7354444 171.517913,39.6312778 L171.513182,4.76322222 L177.034127,4.76322222 Z" class="ign-letters"></path><path d="M12.5325367,17.4969167 C9.83593119,17.7924722 7.37392202,18.1949722 5.19799235,18.6919167 C7.64553058,12.4408056 12.6357813,7.45969444 18.8983624,5.01636111 C18.4007844,7.18802778 17.9972676,9.64580556 17.7003349,12.3380278 C15.6474083,13.6910833 13.8875183,15.44775 12.5325367,17.4969167 Z M37.561544,12.2788056 C37.2481924,9.60102778 36.8327092,7.15852778 36.3292872,4.99852778 C42.6141312,7.43463889 47.6238621,12.4246389 50.0786358,18.6915833 C47.9018713,18.1949167 45.4401404,17.7924167 42.7435349,17.4968611 C41.3866052,15.4454722 39.6247673,13.6876944 37.5690578,12.3343611 C37.5659966,12.3154722 37.5651618,12.2976944 37.561544,12.2788056 Z M17.7001401,42.4921667 C17.9967945,45.1849444 18.4005896,47.6427222 18.8978893,49.8141111 C12.6219505,47.3655 7.62446422,42.3677222 5.18249174,36.098 C7.32419205,36.5932778 9.75586789,37.0027222 12.4711187,37.3216111 C12.4911554,37.3252222 12.5100789,37.3260556 12.5298373,37.3296667 C13.8850972,39.3799444 15.645822,41.1382778 17.7001401,42.4921667 Z M42.8041737,37.3216667 C45.5171982,37.005 47.9485957,36.5963889 50.092244,36.1008333 C47.6444275,42.3855556 42.6271829,47.3911111 36.3298159,49.8316667 C36.8326813,47.6727778 37.2481645,45.2316667 37.5615162,42.555 C37.5654122,42.535 37.5662471,42.5161111 37.5695865,42.4961111 C39.6264092,41.1422222 41.3893602,39.3830556 42.7460116,37.3297222 C42.76577,37.3263889 42.7844153,37.3252778 42.8041737,37.3216667 Z M55.0276165,22.9458611 L55.0276165,31.83475 C50.8179621,33.7775278 44.5431364,34.5544722 42.4245339,34.7994722 C41.9135982,34.8958611 41.4360569,34.9414167 40.9740997,34.9414167 L34.2284116,27.4155833 L40.9740997,19.8889167 C41.3628673,19.8889167 41.7716716,19.9266944 42.2236104,20.0039167 C44.3923046,20.2350278 50.7726012,20.9803056 55.0276165,22.9458611 Z M14.3035859,19.8889167 L21.0476043,27.4155833 L14.3035859,34.9414167 C13.8405156,34.9414167 13.3615829,34.8958611 12.8520385,34.7994722 C10.7342709,34.5528056 4.45777554,33.7775278 0.247007951,31.8325278 L0.247007951,22.9478056 C4.5028581,20.9803056 10.8837113,20.2350278 13.0510141,20.0039167 C13.5060141,19.9266944 13.9137052,19.8889167 14.3035859,19.8889167 Z M20.098644,40.7283611 L27.6388428,33.99475 L35.1782067,40.7283611 C35.1782067,41.1889167 35.1311761,41.6666944 35.0346104,42.1761389 C34.7894391,44.2889167 34.0088428,50.5530833 32.0619437,54.7550278 L23.160641,54.7550278 C21.1898092,50.5091944 20.4439988,44.1391944 20.2121853,41.9755833 C20.1356563,41.5253056 20.098644,41.1153056 20.098644,40.7283611 Z M23.160641,0.0764166667 L32.0619437,0.0764166667 C34.0088428,4.28058333 34.7894391,10.5436389 35.0346104,12.6578056 C35.1311761,13.1669722 35.1782067,13.64225 35.1782067,14.1039167 L27.6388428,20.8391944 L20.098644,14.1039167 C20.098644,13.7180833 20.1356563,13.3089167 20.2121853,12.8575278 C20.4439988,10.6930833 21.1898092,4.32363889 23.160641,0.0764166667 Z" fill="#BF1313"></path></g></svg>
            <p class="verdict">{game.reviews['ign'].verdict}&nbsp—&nbsp;{game.reviews['ign'].score}/10</p>
            <a href="{game.reviews['ign'].url}">Read More</a><br />
        </center>
        </div>
    {/if}

    {#if game.prices != null && game.prices['usd'] != 0 }
    <br /><br />
    <h2>Prices</h2>
    <div class="cat">
        <table class="pure-table pure-table-horizontal pure-table-striped">
            <thead>
                <td>Currency</td>
                <td>Price</td>
                <td>Lowest Recorded Price</td>
            </thead>
            <tbody>
                {#each currencies as cur}
                {#if game.prices[cur.shorthand] == null}
                <tr>
                    <td>{cur.name}</td>
                    <td>Not available</td>
                    <td></td>
                </tr>
                {:else if game.prices[cur.shorthand] != 0}
                <tr>
                    <td>{cur.name}</td>
                    <td>{cur.prefix}{game.prices[cur.shorthand]}{cur.suffix}</td>
                    {#if isNaN(game.lrd) && game.lrd != null}
                        <td>{cur.prefix}{(game.prices[cur.shorthand] * (isNaN(1.0 - game.lrd[cur.shorthand]) ? 1.0 : isNaN(game.lrd[cur.shorthand]) ? 0 : (1.0 - game.lrd[cur.shorthand]))).toFixed(2)}{cur.suffix}</td>
                    {:else}
                        <td>{cur.prefix}{(game.prices[cur.shorthand] * (isNaN(1.0 - game.lrd) ? 1.0 : (1.0 - game.lrd))).toFixed(2)}{cur.suffix}</td>
                    {/if}
                </tr>
                {/if}
                {/each}
            </tbody>
        </table>
    </div>
    {/if}

    <Collection path={`games/${sku}/sales`} query={(ref) => ref.orderBy('start')} let:data={sales}>
        {#if sales.length != 0}
        <h2>All Sales</h2>
        <div class="cat">
            <table class="pure-table pure-table-horizontal pure-table-striped">
                <thead>
                    <td>Start Date</td>
                    <td>End Date</td>
                    <td>Pro</td>
                    <td>Amount</td>
                    <td>Price</td>
                </thead>
                <tbody>
                    {#each sales as sale}
                        {#if sale.discount[currency.shorthand] != null || sale.discount > 0 }
                            <tr>
                                <td>{convertTime(sale.start)}{sale.end.toDate() > Date.now() ? ' (ongoing)' : ''}</td>
                                <td>{convertTime(sale.end)}</td>
                                <td>{#if sale.pro}<img src="/img/stadia_pro_badge_small.svg" class="pro-badge" alt="pro" />{/if}</td>
                                {#if isNaN(sale.discount)}
                                    <td>{(sale.discount[currency.shorthand] * 100).toFixed()}%</td>
                                    {#if game.prices.archive == null}
                                        {#if game.prices[currency.shorthand] != null}
                                            <td>{currency.symbol}{(game.prices[currency.shorthand] * (1.0 - sale.discount[currency.shorthand])).toFixed(2)}</td>
                                        {:else}
                                            <td>Not available</td>
                                        {/if}
                                    {:else}
                                        {#if game.prices.archive[game.prices.archive.length - 1]['before'].toDate() < sale.start.toDate()}
                                            {#if game.prices[currency.shorthand] != null}
                                                <td>{currency.symbol}{(game.prices[currency.shorthand] * (1.0 - sale.discount[currency.shorthand])).toFixed(2)}</td>
                                            {:else}
                                                <td>Not available</td>
                                            {/if}
                                        {:else}
                                            <td>{currency.symbol}{(game.prices.archive.find(el => el['before'].toDate() > sale.start.toDate())[currency.shorthand] * (1.0 - sale.discount[currency.shorthand])).toFixed(2)}</td>
                                        {/if}
                                    {/if}
                                {:else}
                                    <td>{(sale.discount * 100).toFixed()}%</td>
                                    {#if game.prices.archive == null}
                                        {#if game.prices[currency.shorthand] != null}
                                            <td>{currency.symbol}{(game.prices[currency.shorthand] * (1.0 - sale.discount)).toFixed(2)}</td>
                                        {:else}
                                            <td>Not available</td>
                                        {/if}
                                    {:else}
                                        {#if game.prices.archive[game.prices.archive.length - 1]['before'].toDate() < sale.start.toDate()}
                                            {#if game.prices[currency.shorthand] != null}
                                                <td>{currency.symbol}{(game.prices[currency.shorthand] * (1.0 - sale.discount)).toFixed(2)}</td>
                                            {:else}
                                                <td>Not available</td>
                                            {/if}
                                        {:else}
                                            <td>{currency.symbol}{(game.prices.archive.find(el => el['before'].toDate() > sale.start.toDate())[currency.shorthand] * (1.0 - sale.discount)).toFixed(2)}</td>
                                        {/if}
                                    {/if}
                                {/if}
                            </tr>
                        {/if}
                    {/each}
                </tbody>
            </table>
        </div>
        {/if}
    </Collection>
</Doc>

<style>
    .logo {
        max-width: 300px;
    }

    .ign-letters {
        fill: #212121;
    }

    :global(main.dark) .ign-letters {
        fill: #eeeeee;
    }

    .banner {
        background: #eeeeee;
        padding: 10px;
        padding-left: 5vw;
        padding-right: 5vw;
        width: 90vw;
        text-align: center;
    }

    .verdict {
        font-size: 2em;
        padding-left: 5vw;
        padding-right: 5vw;
        margin: 20px;
        font-style: italic;
        max-width: 1200px;
    }

    :global(main.dark) .banner {
        background: #212121;
    }

    .details>div {
        margin-left: 5vw;
        margin-right: 5vw;
        border-radius: 5px;
        padding: 25px;
        background: #eeeeee;
    }

    :global(main.dark) .details>div {
        background: #212121;
    }

    .nonul {
        padding: 5px;
    }

    .nonul>li {
        padding: 15px;
    }

    .nonul>li:nth-child(even) {
        background: #fff;
    }

    :global(main.dark) .nonul>li:nth-child(even) {
        background: #121212;
    }

    .pure-button { 
        color: black;
        width: calc(100% - 5px);
    }

    .invert {
        filter: invert(1);
    }

    :global(main.dark) .invert {
        filter: invert(0);
    }

    .nonInverted {
        display: none;
    }

    .inverted {
        display: initial;
    }

    :global(main.dark) .nonInverted {
        display: initial;
    }

    :global(main.dark) .inverted {
        display: none;
    }

    .cat {
        overflow-x: scroll;
        display: block;
    }

    :global(main.dark) .cat {
        color: #212121;
        filter: invert(1);
    }

    :global(.item:hover td) {
        background: #cbcbcb !important;
    }

    :global(main.dark) .cat .load-more td:hover {
        background: #cbcbcb !important;
    }

    .pro-badge {
        vertical-align: middle;
    }

    table .pro-badge {
        filter: invert(0);
    }

    :global(main.dark) table .pro-badge {
        filter: invert(1);
    }

    .notice {
        background: #eeeeee;
        padding: 10px;
        padding-left: 5vw;
        padding-right: 5vw;
        width: 90vw;
    }

    :global(main.dark) .notice {
        background: #212121;
    }
</style>